// eslint-disable-next-line
import util from 'util';

import React, { Component, useMemo } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as coreSelectors from '../core/selectors';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import * as ServiceIcons from './Icons';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchieveIcon from '@material-ui/icons/Unarchive';
import { Document, Image, PDFDownloadLink, Page, Text, View } from '@react-pdf/renderer';
import logo from '../images/rubyNavLogo.png';


const styles = theme => ({
  ...MessageFormat.styles(theme),
});

const DownloadPdf = ({MyDoc,invoiceId,LoadingBtn}) => {    

  return useMemo(
    () => {
          return (<PDFDownloadLink document={<MyDoc />} style={{textDecoration:'none'}} fileName="Chat Export.pdf">
            {({ blob, url, loading, error }) => (loading ? <MuiCore.CircularProgress color="primary"/> : <LoadingBtn /> )}
          </PDFDownloadLink>)
    },
    [],
  )
}

class ChatFormat extends Component {

    state = {
        mouseState: null,
        showChat: false
    }

    formatDuration = (durationInSeconds, round) => {
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = Math.floor(durationInSeconds % 60);
    
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');
    
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    };

    calculateDuration = (firstMessageTime, thisMessageTime) => {
      let difference = new Date(thisMessageTime).getTime() - new Date(firstMessageTime).getTime();
      let differenceInSec = Math.round(difference/1000);
      return this.formatDuration(differenceInSec);
    }

    removeHtmlTags = (input) => {
      if(input){
        return input.replace(/<\/?[^>]+(>|$)/g, '');
      } else {
        return '-';
      }
    }

  render() {
    /* eslint-disable */
    const { classes, message, user, generateChatExport, markPurechatRead, setContactChanged, 
            markPurechatArchived, markPurechatFollowup, setActivityDetailOpen } = this.props;

    let phoneNumbers = [];
    user?.patchNumbers?.forEach(number => {
      phoneNumbers.push(number.phoneNumber);
    })

    let allSms = message?.messages || [];

    let sender;
    if (Boolean(message.visitorFullName)) {
      sender= message.visitorFullName;
    }

    const MyDoc = () => {
      let firstMessageTime = message?.messages?.length > 0 ? message.messages[0].created : null;
      let accountName = user?.userAccountRoles?.filter(role => role.accountId === message.accountId)[0].accountName;
      return (
        <Document>
          <Page size="A4" style={{fontSize: 11,paddingTop: 40,paddingLeft:60,paddingRight:60,paddingBottom:40,lineHeight: 2,flexDirection: 'column'}}>
            <View style={{height: 60,width:'100%',backgroundColor: 'white'}}>
              <Image style={{width: 110,height: 50,marginLeft: 'auto',marginRight: 'auto'}} src={logo}/>
            </View>
            <View>
              <Text style={{fontSize: 20}}>Chat Transcript</Text>
            </View>
            <View style={{width: '100%', flexDirection: 'row'}}>
              <View style={{width: '50%', padding: 5}}>
                <Text style={{fontSize: 15}}>CHAT INFORMATION</Text>
                <View style={{flexDirection: 'row', width: '100%'}}>
                  <View style={{width: '50%'}}>
                    <Text style={{fontSize: 11}}>Date:</Text>
                    <Text style={{fontSize: 11}}>Chat Start Time:</Text>
                    <Text style={{fontSize: 11}}>Chat End Time:</Text>
                    <Text style={{fontSize: 11}}>Chat ID:</Text>
                    <Text style={{fontSize: 11}}>Outcome:</Text>
                    <Text style={{fontSize: 11}}>Chat Specialist:</Text>
                    <Text style={{fontSize: 11}}>Chat Duration:</Text>
                  </View>
                  <View style={{width: '50%'}}>
                    <Text style={{fontSize: 11}}>{new Date(message.created).toLocaleDateString()}</Text>
                    <Text style={{fontSize: 11}}>{new Date(message.created).toLocaleTimeString()}</Text>
                    <Text style={{fontSize: 11}}>{new Date(message.ended).toLocaleTimeString()}</Text>
                    <Text style={{fontSize: 11}}>{message.chatId}</Text>
                    <Text style={{fontSize: 11}}>{message.outcome ? message.outcome : '-'}</Text>
                    <Text style={{fontSize: 11}}>{message.agentFullName ? message.agentFullName : '-'}</Text>
                    <Text style={{fontSize: 11}}>{message.chatDuration ? this.formatDuration(message.chatDuration) : '-'}</Text>
                  </View>
                </View>
              </View>
              <View style={{width: '50%', padding: 10}}>
                <Text style={{fontSize: 15}}>CUSTOMER INFORMATION</Text>
                  <View style={{flexDirection: 'row', width: '100%'}}>
                    <View style={{width: '50%'}}>
                      <Text style={{fontSize: 11}}>From Name:</Text>
                      <Text style={{fontSize: 11}}>From Number:</Text>
                      <Text style={{fontSize: 11}}>From Email:</Text>
                      <Text style={{fontSize: 11}}>Address:</Text>
                    </View>
                    <View style={{width: '50%'}}>
                      <Text style={{fontSize: 11}}>{message.visitorFullName}</Text>
                      <Text style={{fontSize: 11}}>{message.visitorPhone ? Formatters.formatPhoneNumber(message.visitorPhone) : '-'}</Text>
                      <Text style={{fontSize: 11}}>{message.visitorEmail ? message.visitorEmail : '-'}</Text>
                      <Text style={{fontSize: 11}}>{message.visitorLocation ? message.visitorLocation : '-'}</Text>
                    </View>
                  </View>
              </View>
            </View>
            <View style={{width: '100%', flexDirection: 'row'}}>
              <View style={{width: '25%', padding: 5}}>
                <Text style={{fontSize: 11}}>Actions:</Text>
              </View>
              <View style={{width: '60%'}}>
                <Text style={{fontSize: 11}}>{this.removeHtmlTags(message.actions)}</Text>
              </View> 
            </View>
            <Text style={{fontSize: 15}}>COMPANY INFORMATION</Text>
            <View style={{width: '100%', flexDirection: 'row'}}>
              <View style={{width: '25%'}}>
                <Text style={{fontSize: 11}}>Company:</Text>
                <Text style={{fontSize: 11}}>Website:</Text>
                {/* <Text style={{fontSize: 11}}>Source:</Text> */}
              </View>
              <View style={{width: '75%'}}>
                <Text style={{fontSize: 11}}>{accountName ? accountName : '-'}</Text>
                <Text style={{fontSize: 11}}>{message.website}</Text>
                {/* <Text style={{fontSize: 11}}></Text> */}
              </View>
            </View>
            <Text style={{fontSize: 15}}>TRANSCRIPT</Text>
              {message.messages?.map(sms => (
                sms.author === message.visitorFullName ? 
                <View style={{width: '100%', flexDirection: 'row', backgroundColor: '#F8F8F9', padding: 7}}>
                  <View style={{width: '25%'}}>
                    <Text style={{fontSize: 11, color: '#09122B', marginTop: 5, marginLeft: 5}}>{sms.author}</Text>
                    <Text style={{fontSize: 8, color: '#09122B', marginLeft: 5, marginTop: -5}}>{this.calculateDuration(firstMessageTime, sms.created)}</Text>
                  </View>
                  <View style={{width: '75%', marginTop: 5}}>
                    <Text style={{fontSize: 11}}>{sms.message}</Text>
                  </View>
                </View>
                : 
                <View style={{width: '100%', flexDirection: 'row', padding: 7}}>
                  <View style={{width: '25%'}}>
                    <Text style={{fontSize: 11, color: '#EE9CA1', marginTop: 5, marginLeft: 5}}>{sms.author}</Text>
                    <Text style={{fontSize: 8, color: '#EE9CA1', marginLeft: 5, marginTop: -5}}>{this.calculateDuration(firstMessageTime, sms.created)}</Text>
                  </View>
                  <View style={{width: '75%', marginTop: 5}}>
                    <Text style={{fontSize: 11}}>{sms.message}</Text>
                  </View>
                </View> 
              ))}
            <Text style={{fontSize: 11, marginTop: 10}}>Ruby, 805 SW Broadway, Suite 900, Portland, OR 97205</Text>
            <Text style={{fontSize: 11}}>Questions? Contact us at staff@ruby.com</Text>
          </Page>
        </Document>
      )
    }

    
    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          {sender}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.created)}
        </div>
        <div className={classes.messageSender}>
          {message.types}
        </div>

        <MuiCore.Grid item>
            <MuiCore.Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 10}}>
            <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.visitorPhone && 'pointer'}} onClick={() => {
                if(message.visitorPhone){
                  this.props.newContact(message.visitorPhone, message.visitorEmail, message.visitorFullName);
                  setContactChanged(true);
                }
              }}>
                <MuiCore.Grid item style={{height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 11, color: message.visitorPhone ? '#122457' : 'grey'}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                {/* <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 11, color:'#122457'}}/> */}
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Save contact
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  markPurechatRead(message.chatId, 'Y');
                  setActivityDetailOpen(false);
                }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50, marginLeft: 10}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      <MuiCore.SvgIcon xmlns="http://www.w3.org/2000/svg" width="31.5" height="21" viewBox="0 0 31.5 21" style={{color: '#122457', marginTop: 13}}>
                        <path d="M.6.99V16.571L11.439,9.345ZM16.294,13.3l-3.726-2.823L.6,18.49V21.2H32.1V18.49L19.907,10.361Zm15.694,3.387V1.1L21.149,9.458ZM16.294,11.265,30.52.2H2.068Z" transform="translate(-0.6 -0.2)"/>
                      </MuiCore.SvgIcon>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                    {'Mark unread'}
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  if(message.archived){
                    markPurechatArchived(message.chatId, 'Y');
                  }else {
                    markPurechatArchived(message.chatId, 'N');
                  }
                  setActivityDetailOpen(false);
                  }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      {message.archived ? <UnarchieveIcon fontSize='medium' style={{marginTop: 11, color:'#122457'}}/> : <ArchiveIcon fontSize='medium' style={{marginTop: 11, color:'#122457'}}/>}
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  {message.archived ? 'Unarchive': 'Archive'}
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                      this.props.openAssist();
                    }}>
                    <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                      <MuiCore.Grid item >
                        <ServiceIcons.AssistIcon  style={{marginTop: 12}}/>
                      </MuiCore.Grid>
                    </MuiCore.Grid>
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                      Assist
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  if(message.followup === 'Y'){
                    markPurechatFollowup(message.chatId, 'N')
                  }else {
                    markPurechatFollowup(message.chatId, 'Y')
                  }
                }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      <ServiceIcons.FollowupIcon style={{color: '#122457', marginTop: 11}} followup={message.followup}/>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                    Follow Up
                  </MuiCore.Typography>
                </MuiCore.Grid>
                
              </MuiCore.Grid>
          </MuiCore.Grid>
        <MuiCore.Divider/>

        {<MuiCore.Grid style={{maxHeight: 350, overflow: 'auto'}}>
          <div className={classes.sectionHeader} style={{marginTop: 20}}>
                Outcome: <span className={classes.fieldData}>{message.outcome}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 20}}>
                From Name: <span className={classes.fieldData}>{message.visitorFullName}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                From Number: <span className={classes.fieldData}>{Formatters.formatPhoneNumber(message.visitorPhone)}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                From Email: <span className={classes.fieldData}>{message.visitorEmail}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                Address: <span className={classes.fieldData}>{message.visitorLocation}</span>
            </div>

            <div className={classes.sectionHeader} style={{marginTop: 20}}>
                Actions: <span className={classes.fieldData} dangerouslySetInnerHTML={{__html: message.actions}}></span>
            </div>

            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                To: <span className={classes.fieldData}>{message.website}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                Date: <span className={classes.fieldData}>{MessageFormat.formatDateTime(message)}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                Chat ID: <span className={classes.fieldData}>{message.chatId}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                Chat Specialist: <span className={classes.fieldData}>{message.agentFullName}</span>
            </div>
            <div className={classes.sectionHeader} style={{marginTop: 5}}>
                Chat Duration: <span className={classes.fieldData}>{this.formatDuration(message.chatDuration)}</span>
            </div>

            <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 20}}>
                <div className={classes.sectionHeader} style={{marginTop: 5}}>
                <MuiCore.Typography className={classes.filterText} style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'viewChatTranscript' ? '#E5196C' : '#09122B', fontWeight: 400}}>
                    <span style={{cursor: 'pointer'}} onClick={() => this.setState({showChat: !this.state.showChat})} onMouseEnter={()=>{this.setState({mouseState: 'viewChatTranscript'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                        {this.state.showChat ? 'Hide chat transcript' : 'View chat transcript'}
                    </span>
                </MuiCore.Typography>
                </div>
                <div className={classes.sectionHeader} style={{marginTop: 5, marginRight: 10}}>
                      <DownloadPdf MyDoc={MyDoc} invoiceId={123} LoadingBtn={() => (
                        <MuiCore.Typography className={classes.filterText} style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'export' ? '#E5196C' : '#09122B', fontWeight: 400}}>
                          <span style={{cursor: 'pointer'}} onMouseEnter={()=>{this.setState({mouseState: 'export'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                              {'Export'}
                          </span>
                        </MuiCore.Typography>
                      )}/>
                </div>
            </MuiCore.Grid>

            <MuiCore.Hidden xlDown={!this.state.showChat}>
                <MuiCore.Grid>
                    <div style={{marginTop: 10, display: 'flex', flexDirection: 'column', marginBottom: 10}}>
                        {/* {allSms.map((sms) => (
                            <div style={sms.author === message.visitorFullName ? {display: 'flex', flexDirection: 'row'} : {}}>
                            {sms.author === message.visitorFullName && <AccountCircle fontSize='small' style={{ marginBottom: 0, marginTop: 'auto', color: '#EF9CA1' }}/>}
                            <div className={sms.author === message.visitorFullName ? classes.receivedMessageData : classes.sentMessageData}>
                                {sms.message}
                            </div>
                            </div>
                        ))} */}
                        <MuiCore.Typography style={{fontSize: 18, margin: 5, fontFamily: 'Sofia-bold'}}>Chat Transcript</MuiCore.Typography>
                        <MuiCore.Table>
                          {allSms.map((sms) => (<MuiCore.TableRow style={{backgroundColor: sms.author === message.visitorFullName && '#F8F8F9'}}>
                            <MuiCore.TableCell style={{fontFamily: 'Sofia-bold', width: 110, fontSize: 14, color: sms.author !== message.visitorFullName ? '#EE9CA1' : '#09122B'}}>{sms.author}</MuiCore.TableCell>
                            <MuiCore.TableCell style={{fontSize: 14}}>{sms.message}</MuiCore.TableCell>
                          </MuiCore.TableRow>))}
                        </MuiCore.Table>
                    </div>
                </MuiCore.Grid>
            </MuiCore.Hidden>

        </MuiCore.Grid>}

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>       
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
    messages : serviceSelectors.getMessages(state),
    user: coreSelectors.getUser(state)
  });
};

const mapDispatchToProps = {
  archiveMessage : serviceActions.archiveMessage,
  unarchiveMessage : serviceActions.unarchiveMessage,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  generateChatExport : serviceActions.generateChatExport,
  markPurechatRead: serviceActions.markPurechatRead,
  markPurechatArchived: serviceActions.markPurechatArchived,
  markPurechatFollowup: serviceActions.markPurechatFollowup,
  openAssist : serviceActions.openAssist,
  newContact : serviceActions.newContact,
  setContactChanged : serviceActions.setContactChanged,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(ChatFormat));

